import axios from 'axios';
import { useCallback } from 'react';
import { API_URL } from '../../config';

export const DEFAULT_GROUP_ID = 0;

export default function useAuthQueries() {
  const register = useCallback(
    ({ company, first_name, last_name, email, username, password }) => {
      const url = `${API_URL}/account/register/`;
      return axios.post(url, {
        company,
        first_name,
        last_name,
        email,
        username,
        password,
      });
    },
    []
  );

  const sendResetPasswordLink = useCallback(({ email }) => {
    const url = `${API_URL}/_allauth/app/v1/auth/password/request`;
    return axios.post(url, { email });
  }, []);

  const resetPassword = useCallback(({ key, password, config }) => {
    const url = `${API_URL}/_allauth/app/v1/auth/password/reset`;
    return axios.post(
      url,
      {
        password,
        key,
      },
      { ...config }
    );
  }, []);

  const login = useCallback(({ username, password }) => {
    const url = `${API_URL}/_allauth/app/v1/auth/login`;
    return axios.post(url, { username, password });
  }, []);

  const logout = useCallback((sessionToken) => {
    const url = `${API_URL}/_allauth/app/v1/auth/session`;
    return axios.delete(url, {
      headers: { 'X-Session-Token': sessionToken },
    });
  }, []);

  // MARK: TOTP
  const getTOTPStatus = useCallback((sessionToken) => {
    const url = `${API_URL}/_allauth/app/v1/account/authenticators/totp`
    return axios.get(url, {
      headers: { 'X-Session-Token': sessionToken },
    })
  }, [])

  const activateAuthenticator = useCallback((code, sessionToken) => {
    const url = `${API_URL}/_allauth/app/v1/account/authenticators/totp`;
    return axios.post(url, {
      code,
    }, {
      headers: { 'X-Session-Token': sessionToken },
    })
  }, [])

  const authenticateWithTOTPCode = useCallback((code, sessionToken) => {
    const url = `${API_URL}/_allauth/app/v1/auth/2fa/authenticate`;
    return axios.post(url, {
      code
    }, {
      headers: { 'X-Session-Token': sessionToken }
    })
  }, [])

  return {
    register,
    sendResetPasswordLink,
    resetPassword,
    getTOTPStatus,
    activateAuthenticator,
    authenticateWithTOTPCode,
    login,
    logout,
  };
}
